/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './AccountService.js';
import './ActivityService.js';
import './AlertEventService.js';
import './AlertRuleService.js';
import './AuditViewService.js';
import './authservice.js';
import './batchservice.js';
import './billingservice.js';
import './bodyservice.js';
import './BulkRestoreData.js';
import './BulkRestoreService.js';
import './CacheService.js';
import './ConfigService.js';
import './DashboardService.js';
import './ErrorService.js';
import './GdprRequestService';
import './GdprRequestData';
import './LogService.js';
import './MobileLogService.js';
import './pagingservice.js';
import './PermissionService.js';
import './progress/ProgressService.js';
import './progress/RestoreProgressService.js';
import './SObjectService.js';
import './UserAgentService.js';
import './UtilService.js';
import './viewservice.js';
import './wizardservice.js';
import './UserService.js';
import './Intercom.js';

/**
 * Grouping module used for including all service sub-modules.
 */
angular.module('sbsf.services', [
  'services.account',
  'services.activity',
  'services.alertEvents',
  'services.alertRules',
  'services.auditview',
  'services.auth',
  'services.batch',
  'services.billing',
  'services.body',
  'services.bulkrestore',
  'services.bulkrestoredata',
  'services.cache',
  'services.config',
  'services.dashboard',
  'services.error',
  'services.gdprrequest',
  'services.gdprrequestdata',
  'services.intercom',
  'services.log',
  'services.mobile.log',
  'services.paging',
  'services.permissions',
  'services.progress',
  'services.progress.restore',
  'services.sobject',
  'services.useragent',
  'services.util',
  'services.view',
  'services.wizard',
  'services.users',
  'sbsf.enums'
]);
